import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { UiCardItemDb } from '../redux/uiCardItemDbSlice';

const useUiCardItemDbs = (cardId: string | undefined): [string[], UiCardItemDb[]] => {
  const uiCardItemDb = useSelector((state: RootState) => state.uiCardItemDb);
  const ids = Object.keys(uiCardItemDb.uiCardItems).filter(id => uiCardItemDb.uiCardItems[id].cardId === cardId);
  ids.sort((a, b) => {
    const aValue = uiCardItemDb.uiCardItems[a];
    const bValue = uiCardItemDb.uiCardItems[b];
    return bValue.z - aValue.z;
  })
  const values = ids.map(id => uiCardItemDb.uiCardItems[id]);

  return [ids, values];
}

export default useUiCardItemDbs;
